
<link href="https://fonts.googleapis.com/css2?family=Raleway:wght@400&display=swap" rel="stylesheet">

<div class="wrap">
	<div class="presentation" data-aos="fade-down" data-aos-duration="1500">
		<h2>
			Our Activities
		</h2>
		<p>
			NRW,for this special reason, holds many social activities such as an entertaining team building, which will
			include new,competitive and unusual games and sports, a glowy party, including a dancefloor and DJs, 
			an opening ceremony and a closing ceremony,holding new and different activities
			with artistic breaks, and an important debate session, as well as different success stories that will be told, coming from inspiring and 
			succesful guests, that you definietly don't want to miss!
			these create a great opportunity to socialize, create good friendly vibes between the attendees and just make them enjoy their time and stay.
			take a closer look by participating in one of the many activities out there, and let's start the fun!
		</p>
	</div>
	<div class="gallery">
		<div class="gallery__column">
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/3.png" class="gallery__image">
				</figure>
			</a>
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/6.jpg"  class="gallery__image">
					
				</figure>
			</a>
		
	
			
		</div>
		
		<div class="gallery__column">
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/4.jpg" class="gallery__image">
				
				</figure>
			</a>
			
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/5.jpg"class="gallery__image">
			
				</figure>
			</a>
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/1.jpg" class="gallery__image">
					
				</figure>
			</a>
	
		</div>
		
		<div class="gallery__column">
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/7.jpg"  class="gallery__image">
				
				</figure>
			</a>
			
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/8.png"  class="gallery__image">
				
				</figure>
			</a>
	
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/2.jpg" class="gallery__image">
				
				</figure>
			</a>
		</div>
		
		<div class="gallery__column">
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/9.png" class="gallery__image">
				
				</figure>
			</a>
			<a  target="_blank" class="gallery__link">
				<figure class="gallery__thumb">
					<img src="../../../assets/background/activities/10.png" class="gallery__image">
				
				</figure>
			</a>
		</div>
	</div>
</div>